import { render, staticRenderFns } from "./InformativDiv.vue?vue&type=template&id=fc1e495e&scoped=true&"
import script from "./InformativDiv.vue?vue&type=script&lang=js&"
export * from "./InformativDiv.vue?vue&type=script&lang=js&"
import style0 from "./InformativDiv.vue?vue&type=style&index=0&id=fc1e495e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1e495e",
  null
  
)

export default component.exports